module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.c8bce58.woff2";